export const formatNumber = (number: string | number | null): string => {
    if (number === null) {
        return '';
    }

    const num = typeof number === 'string' ? parseFloat(number) : number;

    if (isNaN(num)) {
        return '';
    }

    return num.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
};
